export const qrcodeMain = [
  {
    name: 'qrcode',
    path: '/qrcode',
    meta: {
      title: '一物一码',
      icon: 'el-icon-postcard'
    }
  },
  {
    name: 'qrcode_dashboard',
    path: '/qrcode/dashboard',
    component: () => import('/@/views/plugins/qrcode/Dashboard.vue'),
    meta: { title: '数据看板' }
  },
  {
    name: 'qrcode_settings',
    path: '/qrcode/settings',
    component: () => import('/@/views/plugins/qrcode/Settings.vue'),
    meta: { title: '基本设置' }
  },
  {
    name: 'qrcode_product',
    path: '/qrcode/product',
    component: () => import('/@/views/plugins/qrcode/Product.vue'),
    meta: { title: '商品管理' }
  },
  {
    name: 'qrcode_batch',
    path: '/qrcode/batch',
    component: () => import('/@/views/plugins/qrcode/Batch.vue'),
    meta: { title: '批次号管理' }
  },
  {
    name: 'qrcode_codes',
    path: '/qrcode/codes',
    component: () => import('/@/views/plugins/qrcode/Codes.vue'),
    meta: { title: '溯源码管理' }
  },
  {
    name: 'qrcode_code_records',
    path: '/qrcode/code_records',
    component: () => import('/@/views/plugins/qrcode/CodeRecords.vue'),
    meta: { title: '溯源码记录' }
  },
  {
    name: 'qrcode_scan_records',
    path: '/qrcode/scan_records',
    component: () => import('/@/views/plugins/qrcode/ScanRecords.vue'),
    meta: { title: '扫码记录' }
  }
]

